import { useState, useEffect, useCallback } from "react";
import { ContainerScroll } from "@/components/ui/container-scroll-animation";

const SLIDES = [
  { src: "https://cpnxwtiyemsrigrtetmd.supabase.co/storage/v1/object/public/assets/analityka_panel.png", label: "Analityka" },
  { src: "https://cpnxwtiyemsrigrtetmd.supabase.co/storage/v1/object/public/assets/kreator_scenariusza.png", label: "Kreator" },
  { src: "https://cpnxwtiyemsrigrtetmd.supabase.co/storage/v1/object/public/assets/biblioteka_panel.png", label: "Biblioteka" },
];

const CROSSFADE_INTERVAL_MS = 5000;

const ClientPanelSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const select = useCallback((i: number) => {
    setActiveIndex(i);
    setIsPaused(true);
  }, []);

  useEffect(() => {
    if (isPaused) return;
    const t = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % SLIDES.length);
    }, CROSSFADE_INTERVAL_MS);
    return () => clearInterval(t);
  }, [isPaused]);

  useEffect(() => {
    if (!isPaused) return;
    const t = setTimeout(() => setIsPaused(false), 8000);
    return () => clearTimeout(t);
  }, [isPaused]);

  return (
    <section id="panel-klienta" className="relative py-20 md:py-28 overflow-hidden scroll-mt-24">
      {/* Smooth chain: CreativeBoard ends in peach #FCCAB0 → lighten toward Pricing blue */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#FCCAB0] via-[#FEE8D9] to-[#FEF3EC]" />
      <div
        className="absolute inset-0"
        style={{
          background: "radial-gradient(ellipse 60% 50% at 50% 60%, rgba(253,224,206,0.2) 0%, transparent 70%)",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ContainerScroll
          titleComponent={
            <div className="space-y-4">
              <p className="text-sm font-semibold tracking-widest uppercase text-orange-600">
                Panel klienta
              </p>
              <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900">
                Odkryj panel klienta<span className="text-primary">.</span>
              </h2>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto">
                Wszystko, czego potrzebujesz — pomysły, scenariusze, analityka i konkurencja — w jednym miejscu.
              </p>
            </div>
          }
        >
          <div className="relative w-full h-full">
            {SLIDES.map((slide, i) => (
              <img
                key={slide.src}
                src={slide.src}
                alt={`Panel klienta — ${slide.label}`}
                className="absolute inset-0 w-full h-full object-contain transition-opacity duration-1000 ease-in-out"
                style={{ opacity: i === activeIndex ? 1 : 0 }}
                loading={i === 0 ? "eager" : "lazy"}
                draggable={false}
              />
            ))}
          </div>
        </ContainerScroll>

        {/* Slide controls */}
        <div className="flex items-center justify-center gap-3 mt-4 md:mt-6">
          {SLIDES.map((slide, i) => (
            <button
              key={i}
              onClick={() => select(i)}
              className={`relative px-4 py-2 rounded-xl text-sm font-medium transition-all duration-300 ${
                i === activeIndex
                  ? "text-gray-900 bg-white scale-105"
                  : "text-gray-500 bg-white/40 border border-gray-200/50 hover:bg-white/60 hover:text-gray-700"
              }`}
              style={i === activeIndex ? {
                boxShadow: "0 4px 16px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.8)",
              } : {
                boxShadow: "0 1px 3px rgba(0,0,0,0.04), inset 0 1px 0 rgba(255,255,255,0.4)",
              }}
            >
              {slide.label}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientPanelSection;
